import { render, staticRenderFns } from "./ProfileSettings.Vue?vue&type=template&id=fd8bc488"
import script from "./ProfileSettings.Vue?vue&type=script&lang=js"
export * from "./ProfileSettings.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/ProfileSettings.Vue
// module id = 235
// module chunks = 0